module.exports = __webpack_public_path__ + "img/icon-note.44d2bf9e.svg";